import { UpdateReason } from 'APP/constants/scroll';
import Entities from 'STORE';

export function handleScrollPosition(): void {
  if (Entities.App.isFocused) {
    Entities.ChatStore.setScrollChanged(UpdateReason.NewMessage, {
      isAnimated: true,
    });
  } else {
    Entities.ChatStore.setScrollChanged(UpdateReason.ScrollUnfocusedChat, {
      isAnimated: true,
    });
  }
}
